/**
 * Luma Group
 *
 * @author Robuust
 * @author Jurriën Peters <jurrien@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';

/**
 * Menu controller.
 */
export default class extends Controller {
  /**
   * On scroll.
   */
  onScroll() {
    this.element.classList.toggle('has-scrolled', window.scrollY >= 10);
  }

  /**
   * Toggle menu.
   */
  toggleMenu() {
    this.element.classList.toggle('menu-open');
  }
}
